/**
 * Register the GoStreet service worker.
 * Called once from src/index.js on production build (and in preview/dev when /service-worker.js is served).
 */
export function registerServiceWorker() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((reg) => {
        // Handle updates: when a new SW is installed, prompt to activate
        if (reg.waiting) {
          reg.waiting.postMessage({ type: "SKIP_WAITING" });
        }
        reg.addEventListener("updatefound", () => {
          const newWorker = reg.installing;
          if (!newWorker) return;
          newWorker.addEventListener("statechange", () => {
            if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
              // New version available — activate immediately (silent update; SPA will re-fetch on next nav)
              newWorker.postMessage({ type: "SKIP_WAITING" });
            }
          });
        });
      })
      .catch((e) => {
        // SW registration is best-effort; never block the app.
        console.warn("[gostreet] SW registration failed:", e);
      });

    // Reload page once when the active SW changes (only after the first one is installed)
    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  });
}

/**
 * Ask the browser for permission to show notifications and (in the future) subscribe to push.
 * Returns the permission state ("granted" | "denied" | "default").
 */
export async function requestNotificationsPermission() {
  if (!("Notification" in window)) return "unsupported";
  if (Notification.permission === "granted") return "granted";
  if (Notification.permission === "denied") return "denied";
  try {
    return await Notification.requestPermission();
  } catch {
    return "denied";
  }
}
